import React, { useEffect, useState } from 'react';
import { Phone } from 'react-feather';
import whatsapp from "../src/assets/images/icons/whatsapp.png";
import { appConfig } from './appConfig';
import { trackEvent } from './utils/analytics';



export default function Popup() {

    const [open, setOpen] = useState(false);
    
    // Check if we're on the home page using window.location
    const checkIsHomePage = () => {
        const pathname = window.location.pathname;
        return pathname === `${appConfig.headRoute}/` || pathname === '/' || pathname === '';
    };

    useEffect(() => {
        // Only show popup on home page
        if (!checkIsHomePage()) {
            return;
        }

        // Show popup after 10 seconds delay
        const initialTimer = setTimeout(() => {
            const modal = document.getElementById('my_modal_popup1');
            if (modal && checkIsHomePage()) {
                modal.showModal();
                setOpen(true);
                trackEvent('promo_popup_shown', { source: 'home_promo_popup', trigger: 'initial_delay' });
            }
        }, 10000); // 10 seconds delay

        return () => clearTimeout(initialTimer);
    }, [])

    useEffect(() => {
        // Only show popup on home page
        if (!checkIsHomePage()) {
            return;
        }

        if (!open) {
            // Re-show popup after 3 minutes (180000ms) if closed
            const retryTimer = setTimeout(() => {
                const modal = document.getElementById('my_modal_popup1');
                    if (modal && checkIsHomePage()) {
                        modal.showModal();
                        setOpen(true);
                        trackEvent('promo_popup_shown', { source: 'home_promo_popup', trigger: 'retry_delay' });
                    }
            }, 180000); // 3 minutes (180000ms)

            return () => clearTimeout(retryTimer);
        }

    }, [open])
    return <div>
        <dialog id="my_modal_popup1" className="modal">
            <div className="modal-box w-[60vw] md:w-[35vw]  bg-white rounded-lg ">
                <form method="dialog">
                    {/* if there is a button in form, it will close the modal */}
                    <button className="btn btn-sm btn-circle  absolute right-2 top-2 border-none" onClick={() => { trackEvent('promo_popup_close', { source: 'home_promo_popup' }); setOpen(false) }}>✕</button>
                </form>
                <div className='flex flex-col items-center justify-center gap-2 my-5'>
                    <p className='text-xl md:text-2xl font-bold mt-1'>Save upto 30% off</p>
                    <p className='text-md  font-semibold text-mDarkGray'>Make a Quick Call to our experts on:</p>
                    <div className="flex gap-5 justify-center items-center">
                        <Phone className="" role="button" onClick={() => { trackEvent('phone_click', { source: 'home_promo_popup', phone_number: '03338820922' }); window.location.href = 'tel:03338820922' }} />
                        <img src={whatsapp} className="h-[30px] w-[30px]" alt="WhatsApp" role="button" onClick={() => { trackEvent('whatsapp_click', { source: 'home_promo_popup', phone_number: '923338820922' }); window.open(`https://api.whatsapp.com/send/?phone=923338820922&text=`, '_blank'); }} />

                    </div>

                    <p className='text-md  font-semibold text-mDarkGray'>Save Big on Family & Group Bookings</p>

                </div>


            </div>
        </dialog>
    </div>
}
